import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import injectStyles from 'react-jss'
import { styles } from './style'
import { isEmail } from 'Utils/Validators/email'

const SubmitInput = ({
  onSubmit,
  buttonLabel,
  placeholder,
  actionLabel,
  classes,
  disabled: disabledProps,
  errorText = null,
}) => {
  const [value, setValue] = useState('')
  const [disabled, setDisabled] = useState(true)
  const [showLabel, setShowLabel] = useState(false)
  const [error, setError] = useState(null)
  const timeoutRef = useRef(null)

  useEffect(() => {
    setDisabled(disabledProps)
    if (errorText && disabledProps) {
      setError(errorText)
    } else {
      setError(null)
    }
  }, [disabledProps, errorText])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const isValid = () => {
    if (!value) {
      return false
    }

    if (!isEmail(value)) {
      return false
    }

    return true
  }

  const handleSubmit = async () => {
    if (!isValid()) {
      setError('Not valid email')
      return
    }

    setDisabled(true)
    setError(null)
    try {
      const res = await onSubmit(value)

      if (res && res.success) {
        setValue('')
        setShowLabel(true)
        timeoutRef.current = setTimeout(() => {
          setShowLabel(false)
        }, 3000)
      } else if (res && res.error) {
        setError(res.error)
      }
    } finally {
      setDisabled(false)
    }
  }

  return (
    <div className={classes.inputWrapper}>
      <input
        type="email"
        placeholder={placeholder}
        className={classes.input}
        onChange={e => {
          setValue(e.currentTarget.value)

          if (error) {
            setError(null)
          }
        }}
        value={value}
        disabled={disabled}
      />
      {actionLabel && showLabel ? (
        <div className={classes.actionLabel}>{actionLabel}</div>
      ) : null}
      <button
        className={classNames(classes.button, {
          [classes.buttonDisabled]: disabled || error,
        })}
        onClick={handleSubmit}
        disabled={disabled || error}
      >
        {buttonLabel}
      </button>

      {error && <div className={classes.error}>{error}</div>}
    </div>
  )
}

export default injectStyles(styles)(SubmitInput)
